import React from 'react';
import { useIntl } from 'react-intl';
import { Dropdown } from 'semantic-ui-react';
import DropdownItem from '@/components/DropdownItem';
import AttachmentViewTools from './AttachmentViewTools';
import AttachmentTransferTools from './AttachmentTransferTools';
import Events from '../hooks/events';

const AttachmentTools = ({
  attachment,
  canDownload,
  canIngest,
  canManage,
  canUpdate,
  category,
  code,
  isDownloading,
  isLoading,
}) => {
  const intl = useIntl();
  const showConvertDialog = Events.useShowConvertAttachmentDialog(category, { code });
  const showEditDialog = Events.useShowEditDatasetAttachmentDialog(category, { code });
  const downloadStart = Events.useDatasetAttachmentDownload(category, { code });
  const withDivider = canDownload || canIngest || canManage;

  return (
    <>
      {canDownload && (
        <DropdownItem
          icon="download"
          textId="actions.download"
          onClick={() => downloadStart({ attachment })}
          disabled={isLoading || isDownloading}
        />
      )}
      {canIngest && (
        <DropdownItem
          icon="arrow alternate circle right"
          textId="dataset.convert.title"
          onClick={() => showConvertDialog({ attachment })}
          disabled={isLoading}
        />
      )}
      {canManage && (
        <Dropdown.Item
          icon="edit"
          className="primary"
          text={intl.formatMessage({ id: 'actions.edit.dataset.attachment.description' })}
          as="a"
          onClick={() => showEditDialog({ attachment })}
          disabled={isLoading}
        />
      )}
      {canUpdate && (
        <>
          {withDivider && <Dropdown.Divider />}
          <AttachmentViewTools attachment={attachment} category={category} code={code} disabled={isLoading} />
          <Dropdown.Divider />
          <AttachmentTransferTools attachment={attachment} category={category} code={code} disabled={isLoading} />
          <Dropdown.Divider />
        </>
      )}
    </>
  );
};

export default AttachmentTools;
